<template>
  <div class="manage-campaign col-md-12">
    <h2>Manage Campaign</h2>
    <br/>
    <ul class="nav nav-tabs">
      <li class="active"><a data-toggle="tab" href="#awaiting-approval-campaigns">Awaiting Approval</a></li>
      <li><a data-toggle="tab" href="#launched-campaigns">Lauched Campaigns</a></li>
      <li><a data-toggle="tab" href="#need-more-information-campaigns">Need More Information</a></li>
      <li><a data-toggle="tab" href="#incomplete-campaigns">Incomplete Campaigns</a></li>
    </ul>
    <div class="tab-content">
      <div id="awaiting-approval-campaigns" class="tab-pane fade in active">
        <br />
        <table v-if="awaitingApprovalCampaigns.length">
          <tr style="border-bottom: 1px solid #000;">
            <th>Name</th>
            <th>Status</th>
            <th>Location Type</th>
            <th>Plan</th>
            <th>Company Details</th>
          </tr>
          <tr v-for="camp in awaitingApprovalCampaigns" :key="camp.id" >
            <td>
              <h5>{{ camp.campaign_name }}</h5>
              <ul>
                <li><router-link :to="'/sadmin/' + camp.id +  '/quick-review'">Quick Review</router-link></li>
                <li><router-link :to="'/sadmin/' + camp.id +  '/advanced-review'">Advanced Review</router-link></li>
                <li><a href="#" @click="setCampValue(camp.id);" data-toggle="modal" data-target="#exampleModal">Add notes</a></li>
                <li><a href="#" @click="setCampaignToDelete(camp.id);" data-toggle="modal" data-target="#delete-campaign-popup">Delete Campaign</a></li>
              </ul>
            </td>
            <td><button style="border: 0px;" class="awaiting_approval">Awaiting Approval</button></td>
            <td v-if="camp.geo_location_type == 'any-user-location'">Anywhere</td>
            <td v-if="camp.geo_location_type == 'any-physical-location'">Custom Location</td>
            <td>Free</td>
            <td>Company: {{ camp.name }}<br>
                Email: {{ camp.email }}<br>
                User Name: {{ camp.contact_person_name }}<br>
                Mobile: {{ camp.contact_person_mobile_number }}<br>
                Date: {{ camp.updated_at | humanReadableDate }}
            </td>
          </tr>
        </table>
        <h3 v-else style="text-align: center;">No Pending Campaign For Approval</h3>
        <div class="modal fade note_popup" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h3>Add a Note</h3>
              </div>
              <div class="modal-body">
                <h5>Leave a note for company</h5>
                <textarea placeholder="Type your notes here" v-model="note" name="note"></textarea>
              </div>
              <div class="center">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" ref="exitModel">Exit</button>
                <button type="button" class="btn btn-primary" @click="sendCampaignNote();">Send</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="need-more-information-campaigns" class="tab-pane fade">
        <br />
        <table v-if="needMoreInfo.length">
          <tr style="border-bottom: 1px solid #000;">
            <th>Name</th>
            <th>Status</th>
            <th>Location Type</th>
            <th>Plan</th>
            <th>Company Details</th>
          </tr>
          <tr v-for="camp in needMoreInfo" :key="camp.id" >
            <td>
              <h5>{{ camp.campaign_name }}</h5>
              <ul>
                <li><router-link :to="'/sadmin/' + camp.id +  '/quick-review'">Quick Review</router-link></li>
                <li><router-link :to="'/sadmin/' + camp.id +  '/advanced-review'">Advanced Review</router-link></li>
                <li><a href="#" @click="setCampValue(camp.id);" data-toggle="modal" data-target="#exampleModal">Add notes</a></li>
                <li><a href="#" @click="setCampaignToDelete(camp.id);" data-toggle="modal" data-target="#delete-campaign-popup">Delete Campaign</a></li>
              </ul>
            </td>
            <td>
              <button style="border: 0px;" class="awaiting_approval">Need more information</button>
            </td>
            <td v-if="camp.geo_location_type == 'any-user-location'">Anywhere</td>
            <td v-if="camp.geo_location_type == 'any-physical-location'">Custom Location</td>
            <td>Free</td>
            <td>Company: {{ camp.name }}<br>
                Email: {{ camp.email }}<br>
                User Name: {{ camp.contact_person_name }}<br>
                Mobile: {{ camp.contact_person_mobile_number }}<br>
                Date: {{ camp.updated_at | humanReadableDate }}</td>
          </tr>
        </table>
        <h3 v-else style="text-align: center;">No Need More Information Campaigns For Now</h3>
      </div>
      <div id="incomplete-campaigns" class="tab-pane fade">
        <br />
        <table v-if="incompletes.length">
          <tr style="border-bottom: 1px solid #000;">
            <th>Name</th>
            <th>Status</th>
            <th>Location Type</th>
            <th>Plan</th>
            <th>Company Details</th>
          </tr>
          <tr v-for="camp in incompletes" :key="camp.id" >
            <td>
              <h5>{{ camp.campaign_name }}</h5>
              <h6 style="font-size: 15px; font-weight: 400;">Drop out: {{ getDropOutReason(camp)}}</h6>
              <ul style="padding: 0px !important; border: 0px;">
                <!-- <li><router-link :to="'/sadmin/' + camp.id +  '/quick-review'">Quick Review</router-link></li>
                <li><router-link :to="'/sadmin/' + camp.id +  '/advanced-review'">Advanced Review</router-link></li>
                <li><a href="#" @click="setCampValue(camp.id);" data-toggle="modal" data-target="#exampleModal">Add notes</a></li> -->
                <li><a href="#" @click="setCampaignToDelete(camp.id);" style="background: #f00; color: #fff;padding: 3px 8px;border-radius: 8px;" data-toggle="modal" data-target="#delete-campaign-popup">Delete</a></li>
              </ul>
            </td>
            <td>
              <button style="border: 0px;" class="awaiting_approval">Incomplete</button>
            </td>
            <td v-if="camp.geo_location_type == 'any-user-location'">Anywhere</td>
            <td v-if="camp.geo_location_type == 'any-physical-location'">Custom Location</td>
            <td>Free</td>
            <td>Company: {{ camp.name }}<br>
                Email: {{ camp.email }}<br>
                User Name: {{ camp.contact_person_name }}<br>
                Mobile: {{ camp.contact_person_mobile_number }}<br>
                Date: {{ camp.updated_at | humanReadableDate }}</td>
          </tr>
        </table>
        <h3 v-else style="text-align: center;">No Incomplete Campaigns For Now</h3>
      </div>

      <div id="launched-campaigns" class="tab-pane fade">
        <br />
        <table v-if="launchedCampaigns.length">
          <tr style="border-bottom: 1px solid #000;">
            <th>Name</th>
            <th>Status</th>
            <th>Location Type</th>
            <th>Plan</th>
            <th>Company Details</th>
          </tr>
          <tr v-for="camp in launchedCampaigns" :key="camp.id" >
            <td>
              <h5>{{ camp.campaign_name }}</h5>
              <ul>
                <li><router-link :to="'/sadmin/' + camp.id +  '/quick-review'">Quick Review</router-link></li>
                <li><router-link :to="'/sadmin/' + camp.id +  '/advanced-review'">Advanced Review</router-link></li>
                <li><a href="#" @click="setCampValue(camp.id);" data-toggle="modal" data-target="#exampleModal">Add notes</a></li>
                <li><a href="#" @click="setCampaignToDelete(camp.id);" data-toggle="modal" data-target="#delete-campaign-popup">Delete Campaign</a></li>
              </ul>
            </td>
            <td>
              <button style="border: 0px;" class="awaiting_approval">Lauched</button>
            </td>
            <td v-if="camp.geo_location_type == 'any-user-location'">Anywhere</td>
            <td v-if="camp.geo_location_type == 'any-physical-location'">Custom Location</td>
            <td>Free</td>
            <td>Company: {{ camp.name }}<br>
                Email: {{ camp.email }}<br>
                User Name: {{ camp.contact_person_name }}<br>
                Mobile: {{ camp.contact_person_mobile_number }}<br>
                Date: {{ camp.updated_at | humanReadableDate }}</td>
          </tr>
        </table>
        <h3 v-else style="text-align: center;">No Launched Campaigns For Now</h3>
        <!-- Delete Campaign Popup -->
      </div>
  </div>
  <DeleteCampaignPopup
          popupId="delete-campaign-popup"
          :campaignId="campaignToDelete"
          @campaignDeleted="onCampaignDeleted"
        />
</div>
</template>

<script>
import DeleteCampaignPopup from '@/components/SAdmin/DeleteCampaignPopup.vue'

export default {
  name: 'PlgCampaigns',
  components: {
    DeleteCampaignPopup
  },
  data () {
    return {
      sort: 'id-DESC',
      rowsOffsetAPC: 0,
      rowsLimitPerRequestAPC: 100,
      rowsOffsetLC: 0,
      rowsLimitPerRequestLC: 100,
      note: '',
      picklCampId: '',
      campaignToDelete: 0,
      awaitingApprovalCampaigns: [],
      launchedCampaigns: [],
      needMoreInfo: [],
      incompletes: []
    }
  },
  mounted () {
    this.getAwaitingApprovalCampaigns()
    this.getLaunchedCampaigns()
    this.getNeedMoreCampaigns()
    this.getIncompletesCampaigns()
  },
  methods: {
    getAwaitingApprovalCampaigns () {
      this.loadingStaff = true
      let q = { sort: this.sort, limit: this.rowsLimitPerRequestAPC, offset: this.rowsOffsetAPC, status: 'Awaiting Approval' }
      this.$http
        .get('plg/manage-campaigns', { params: q })
        .then(
          function (response) {
            if (this.rowsLimitPerRequestAPC === q.limit && this.rowsOffsetAPC === q.offset && this.storeSearchQuery === q.name) {
              this.rowsOffsetAPC += this.rowsLimitPerRequestAPC
              this.awaitingApprovalCampaigns.push(...response.body)
              if (this.awaitingApprovalCampaigns.length === response.body.count) {
                this.hasMoreStaff = false
              } else {
                this.hasMoreStaff = true
              }
              this.loadingStaff = false
            }
          }
        )
    },
    getNeedMoreCampaigns () {
      this.loadingStaff = true
      let q = { sort: this.sort, limit: this.rowsLimitPerRequestLC, offset: this.rowsOffsetLC, status: 'Need more information' }
      this.$http
        .get('plg/manage-campaigns', { params: q })
        .then(
          function (response) {
            // if (this.rowsLimitPerRequestLC === q.limit && this.rowsOffsetLC === q.offset && this.storeSearchQuery === q.name) {
            console.log('here we are')
            this.rowsOffsetLC += this.rowsLimitPerRequestLC
            this.needMoreInfo.push(...response.body)
            if (this.needMoreInfo.length === response.body.count) {
              this.hasMoreStaff = false
            } else {
              this.hasMoreStaff = true
            }
            this.loadingStaff = false
          }
          // }
        )
    },
    getIncompletesCampaigns () {
      this.loadingStaff = true
      let q = { sort: this.sort, limit: this.rowsLimitPerRequestLC, offset: this.rowsOffsetLC, status: 'Incomplete' }
      this.$http
        .get('plg/incomplete-campaign', { params: q })
        .then(
          function (response) {
            // if (this.rowsLimitPerRequestLC === q.limit && this.rowsOffsetLC === q.offset && this.storeSearchQuery === q.name) {
            console.log('here we are')
            this.rowsOffsetLC += this.rowsLimitPerRequestLC
            this.incompletes.push(...response.body)
            if (this.incompletes.length === response.body.count) {
              this.hasMoreStaff = false
            } else {
              this.hasMoreStaff = true
            }
            this.loadingStaff = false
          }
          // }
        )
    },
    getLaunchedCampaigns () {
      this.loadingStaff = true
      let q = { sort: this.sort, limit: this.rowsLimitPerRequestLC, offset: this.rowsOffsetLC, status: 'Approved' }
      this.$http
        .get('plg/manage-campaigns', { params: q })
        .then(
          function (response) {
            if (this.rowsLimitPerRequestLC === q.limit && this.rowsOffsetLC === q.offset && this.storeSearchQuery === q.name) {
              this.rowsOffsetLC += this.rowsLimitPerRequestLC
              this.launchedCampaigns.push(...response.body)
              if (this.launchedCampaigns.length === response.body.count) {
                this.hasMoreStaff = false
              } else {
                this.hasMoreStaff = true
              }
              this.loadingStaff = false
            }
          }
        )
    },
    approveCamp (campId) {
      let data = { campId: campId }
      this.$http
        .post('plg/approve-campaigns', data)
        .then((response) => {
          this.$notify({ type: 'success', text: 'Campaign has been successfully approved and is ready to launch!' })
          this.busy = false
          this.campaigns = []
          this.getCampaigns()
        })
    },
    setCampValue (campId) {
      this.picklCampId = campId
    },
    setCampaignToDelete (campId) {
      this.campaignToDelete = campId
    },
    onCampaignDeleted (campaignId) {
      // Remove the deleted campaign from both lists
      this.launchedCampaigns = this.launchedCampaigns.filter(camp => camp.id !== campaignId)
      this.needMoreInfo = this.needMoreInfo.filter(camp => camp.id !== campaignId)
      this.awaitingApprovalCampaigns = this.awaitingApprovalCampaigns.filter(camp => camp.id !== campaignId)
    },
    getDropOutReason (camp) {
      if (camp.survey_id) {
        return 'Survey'
      } else if (camp.product_id) {
        return 'Product'
      } else if (camp.media_id) {
        return 'Media'
      } else if (camp.location_setting_id) {
        return 'Location'
      } else {
        return 'Campaign Setting'
      }
    },
    sendCampaignNote () {
      if (this.note === '') {
        this.$notify({ type: 'error', text: 'Please enter notes' })
        return false
      }
      let data = { campId: this.picklCampId, note: this.note }
      this.$http
        .post('plg/send-campaign-note', data)
        .then((response) => {
          this.$notify({ type: 'success', text: 'Note successfully sent' })
          this.busy = false
          this.$refs.exitModel.click()
          this.campaigns = []
          this.getCampaigns()
        })
    }

  }
}
</script>
<style>
.button-box{
    text-align: center;
    padding: 35px 0;
}
.camp_sett.button-box button {
    border: 0px;
    padding: 6px 30px;
    font-size: 20px;
    font-weight: 500;
    font-family: "Roboto", sans-serif;
    background: #DBDBDB;
    border-radius: 8px;
    margin: 0 10px;
    display: inline !important;
    color: #000;
}
.form-box input{
    border: 0px;
    background: transparent;
    text-transform: uppercase;
    margin-left: 10px;
    outline: none;
}
.camp_sett.button-box .save-continue{
    color: #fff !important;
    background: #12DA6D !important;
}
.campaign-index .box img{
    max-height: 240px;
}
.campaign-index .col-md-5 {
    padding-left: 30px;
}
.form-sidebar {
    border: 3px solid #C7F5DD;
    padding: 20px;
    border-radius: 13px;
    background: #fff;
    margin-bottom: 30px;
    position: relative;
}
.step-number img {
    width: 38px;
}
.step h6{
    margin-top: 10px;
    color: #AAAAAA;
    font-size: 16px;
}
.campaign-index ul{
  list-style: none;
}
.want-to-engage {
  margin-top: 20px;
}
header ul li img {
    height: 30px;
}
.logo img{
  width: 150px;
}
header{
    padding: 10px 0;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);
}
header .col-md-6 li{
  display: inline;
  margin-left: 12px;
}
header .col-md-6 ul{
    float: right;
    margin-bottom: 0px;
    padding: 3.5px 0;
}
header .col-md-6 ul li a {
    color: #000;
    text-decoration: none;
    font-family: "Roboto", sans-serif;
}
header ul li img {
    height: 30px;
}
.manage-campaign table{
    width: 100%;
    border: 1px solid #000;
    margin-bottom: 50px;
}
.manage-campaign h2 {
    text-align: center;
    color: #782B55;
    margin-top: 5px;
    margin-bottom: 20px;
    font-weight: 700;
}
.manage-campaign tr td{
    border-right: 1px solid #000;
}
.manage-campaign th{
    text-align: center;
    font-weight: normal;
    color: #000;
    padding: 8px 5px;
}
.manage-campaign td ul{
    padding: 15px !important;
    border: 1px solid #000;
}
.manage-campaign td ul li a{
    text-decoration: none;
    color: #000;
    font-size: 14px;
}
.manage-campaign td {
    padding: 10px;
}
.manage-campaign td ul li {
    padding-bottom: 4px;
    list-style: none;
}
.manage-campaign h5 {
    font-size: 17px;
    font-weight: normal;
    color: #000;
}
.manage-campaign h5 img{
    width: 19px;
    float: right;
}
.manage-campaign .awaiting_approval{
    background: #84ADE9;
    color: #fff;
    text-decoration: none;
    padding: 8px 15px;
    border-radius: 18px;
    font-size: 14px;
}
.manage-campaign .approved{
    background: #12DA6D;
    color: #fff;
    text-decoration: none;
    padding: 8px 30px;
    border-radius: 18px;
    font-size: 14px;
}
.manage-campaign .launched{
    background: #782B55;
    color: #fff;
    text-decoration: none;
    padding: 8px 30px;
    border-radius: 18px;
    font-size: 14px;
}
.manage-campaign .need_more_information{
    background: #FBBC05;
    color: #fff;
    text-decoration: none;
    padding: 8px 30px;
    border-radius: 18px;
    font-size: 14px;
}

.center{
    text-align: center;
    padding-bottom: 30px;
}
.note_popup .modal-body {
    padding: 10px 20px 15px !important;
}
.note_popup .btn-primary{
    background: #55C287;
    border: 0px;
    padding: 6px 60px;
    font-size: 18px;
    border-radius: 8px;
    margin: 0 10px;
    width: 210px;
}
.note_popup .btn-secondary{
    background: #B4B4B7;
    width: 210px;
    border: 0px;
    padding: 6px 60px;
    font-size: 18px;
    color: #fff;
    border-radius: 8px;
    margin: 0 10px;
}
.note_popup textarea{
      height: 160px;
}
.note_popup .modal-header{
    padding-bottom: 0px;
}
.note_popup h3 {
    margin-top: 0px;
    margin-bottom: 0px;
    text-align: center;
    color: #000;
    font-weight: 500;
}
.note_popup h5{
    font-weight: 500;
    margin-top: 0px;
}

</style>
